// extracted by mini-css-extract-plugin
export default {"copyrightFooter":"CopyrightFooter_copyrightFooter__AwRti"};